import React, { useEffect, useState, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { GallerySection } from './components/GallerySection';
import { FeaturesSection } from './components/FeaturesSection';
import { LocationSection } from './components/LocationSection';
import { UnitsSection } from './components/UnitsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { GalleryPage } from './pages/GalleryPage';
import { UnitsPage } from './pages/UnitsPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  // Google Analytics (gtag.js)
  useEffect(() => {
    // Initialize dataLayer
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () {
      w.dataLayer.push(arguments);
    };
    w.gtag('js', new Date());
    w.gtag('config', 'G-X0FP2EDPSF');
    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-X0FP2EDPSF';
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPath(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Route to AboutPage
  if (currentPath.startsWith('#o-projektu-stranka')) {
    return <AboutPage data-id="element-0" data-mp="38l05w267qx7r" />;
  }
  // Route to GalleryPage
  if (currentPath.startsWith('#cela-galerie')) {
    return <GalleryPage data-id="element-1" data-mp="3dlnwimqj5c1g" />;
  }
  // Route to UnitsPage
  if (currentPath.startsWith('#nabidka-bytu')) {
    return <UnitsPage data-id="element-2" data-mp="nv0ybtt2yq5o" />;
  }
  return <div className="min-h-screen bg-base-cream font-body text-base-dark" data-id="element-3" data-mp="nxwvhfx3tat2">
      <Navbar data-id="element-4" data-mp="sssq8ntq6c9v" />
      <main data-id="element-5" data-mp="swq9d9gaz3tr">
        <HeroSection data-id="element-6" data-mp="36hx792iaw2a" />
        <AboutSection data-id="element-7" data-mp="35yngfn0fdzc" />
        <GallerySection data-id="element-8" data-mp="356sn718lka4" />
        <FeaturesSection data-id="element-9" data-mp="34ndtz6vvc0b" />
        <LocationSection data-id="element-10" data-mp="3uct3bjmdin0h" />
        <UnitsSection data-id="element-11" data-mp="3udkm1tuvgq9c" />
        <ContactSection data-id="element-12" data-mp="3uc9km0owfule" />
      </main>
      <Footer data-id="element-13" data-mp="3uf5lnxw1mze2" />
    </div>;
}